import { GameData, MapObject, LogsObject, LevelObject, PreviousTurrets } from "../types/tower-defense";

export class GameVars {

    public static gameData: GameData;
    public static scaleY: number;
    public static scaleX: number;
    public static aspectRatio: number;
    public static contrascaleX: number;
    public static firstTimeLobby: boolean;
    public static maps: any;
    public static currentScene: Phaser.Scene;
    public static paused: boolean;
    public static battleOver: boolean;
    public static enemiesData: any;
    public static turretsData: any;
    public static modifiers: any;
    public static wavesData: any;
    public static wavesInfo: any;
    public static gameLoaded: boolean;
    public static currentMapData: MapObject;
    public static currentMapZone: number;
    public static currentMapCount: number;
    public static currentWave: number;
    public static levelCompleted: {zone: number, map: number, prevStars: number, totalPrevStars: number, needUnlock: boolean};
    public static coinsBaseEarned: number;
    public static coinsEarned: number;
    public static currentStars: number;
    public static timeStepFactor: number;
    public static enemiesPathsCells: {name: string, path: {r: number, c: number}[]}[];
    public static plateausCells: {r: number, c: number} [];
    public static logsObject: LogsObject;
    public static levelObject: LevelObject;
    public static editorIndex: number;
    public static usePrevTurrets: boolean;
    public static prevTurrets: PreviousTurrets;
    public static levelData: {mapName: string, zone: number, index: number};

    public static areValidDomains(domains: string[]): boolean {

        if (domains.length === 0) {
            return true;
        }

        const hostname = window.location.hostname;
        const referrer = document.referrer;

        let isValid = false;

        for (let i = 0; i < domains.length; i++) {
            if (hostname.indexOf(domains[i]) !== -1) {
                isValid = true;
                break;
            }
        }

        if (referrer) {

            isValid = false;
            
            for (let i = 0; i < domains.length; i++) {

                if (referrer.indexOf(domains[i]) !== -1) {
                    isValid = true;
                    break;
                }
            }
        }

        return isValid;
    }
   
    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    public static getTypefromID(id: string): {type: string, subtype: string} {

        let typeKeys = Object.keys(GameVars.enemiesData);

        for (let i = 0; i < typeKeys.length; i++) {

            let subtypeKeys = Object.keys(GameVars.enemiesData[typeKeys[i]]);
            for (let j = 0; j < subtypeKeys.length; j++) {

                if (GameVars.enemiesData[typeKeys[i]][subtypeKeys[j]].editorId === id) {
                    return {type: typeKeys[i], subtype: subtypeKeys[j]};
                }
            }
        }
        
        return null;
    }
}
